import { generateId } from '@freelancer/datastore/testing/helpers';
import { ContextTypeApi } from 'api-typings/common/common';
import { ContestCollaborationPermissionApi } from 'api-typings/contests/contests';
import { ProjectCollaborationStatusApi } from 'api-typings/projects/projects';
import type { ContestCollaboration } from './contest-collaborations.model';

export interface GenerateContestCollaborationsOptions {
  readonly userIds: readonly number[];
  readonly contestId: number;
  readonly contestOwnerId: number;
  readonly status?: ProjectCollaborationStatusApi;
  readonly permissions?: readonly ContestCollaborationPermissionApi[];
}

export interface GenerateContestCollaborationOptions {
  readonly userId: number;
  readonly contestId: number;
  readonly contestOwnerId: number;
  readonly status?: ProjectCollaborationStatusApi;
  readonly permissions?: readonly ContestCollaborationPermissionApi[];
}

export function generateContestCollaborationObjects({
  userIds,
  contestOwnerId,
  contestId,
  status = ProjectCollaborationStatusApi.ACTIVE,
  permissions,
}: GenerateContestCollaborationsOptions): readonly ContestCollaboration[] {
  return userIds.map(userId =>
    generateContestCollaborationObject({
      userId,
      contestOwnerId,
      contestId,
      status,
      permissions,
    }),
  );
}

export function generateContestCollaborationObject({
  userId,
  contestOwnerId,
  contestId,
  status = ProjectCollaborationStatusApi.ACTIVE,
  permissions = [
    ContestCollaborationPermissionApi.ENTRY_AWARD,
    ContestCollaborationPermissionApi.ENTRY_RATE,
    ContestCollaborationPermissionApi.ENTRY_REJECT,
    ContestCollaborationPermissionApi.ENTRY_JUDGE_RUBRIC,
    ContestCollaborationPermissionApi.ENTRY_VIEW_ALL_SCORES,
  ],
}: GenerateContestCollaborationOptions): ContestCollaboration {
  return {
    id: generateId(),
    userId,
    context: {
      id: contestId,
      type: ContextTypeApi.CONTEST,
    },
    contextOwnerId: contestOwnerId,
    contestCollaborationPermissions: permissions,
    status,
  };
}
